import { render, staticRenderFns } from "./AnswerTask.vue?vue&type=template&id=60381949&scoped=true&"
import script from "./AnswerTask.vue?vue&type=script&lang=js&"
export * from "./AnswerTask.vue?vue&type=script&lang=js&"
import style0 from "./AnswerTask.vue?vue&type=style&index=0&id=60381949&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60381949",
  null
  
)

export default component.exports